import './App.css';
import '../assets/i18n';
import { BrowserRouter } from 'react-router';
import AppRouter from './router';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import { ToastContainer } from 'react-toastify';
import { CommonErrorAlert } from './components/Common/CommonErrorAlert';
import './toastify.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer position="top-center" />
      <CommonErrorAlert />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
